import { mountComponent } from '@/utils';
import { LoadingContainer } from '@/components/shared';
import React, { useEffect, useState } from 'react';
import { CompanyRecreationPlan } from '@/types';
import { useCompanyRecreationPlan } from '../hooks';
import { CompanyRecreationRecreationPlanItem } from './companyRecreationRecreationPlanItem';

const RecreationPlanShow: React.FC = () => {
  const [companyRecreationPlan, setCompanyRecreationPlan] =
    useState<CompanyRecreationPlan>();
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const { fetchCompanyRecreationPlan } = useCompanyRecreationPlan();
  const id = window.location.pathname.split('/')[3];

  useEffect(() => {
    (async () => {
      if (!id || companyRecreationPlan) return;
      try {
        const companyRecreationPlanResponse = await fetchCompanyRecreationPlan(
          id
        );
        setCompanyRecreationPlan({ ...companyRecreationPlanResponse });
        setIsLoading(false);
      } catch (e) {
        console.warn('error is', e);
      }
    })();
  }, [id, companyRecreationPlan, fetchCompanyRecreationPlan]);

  if (isLoading) {
    return <LoadingContainer />;
  }
  if (!companyRecreationPlan) {
    return <></>;
  }
  console.log(companyRecreationPlan);

  return (
    <div>
      <div className='container p-0 mt-4'>
        <div className='d-flex flex-column'>
          <h2 className='plan-title fw-bold'>{companyRecreationPlan.title}</h2>
          <div className='d-flex align-items-center mt-auto'>
            <p className='plan-code mb-0'>
              プラン番号 {companyRecreationPlan.code}
            </p>
          </div>
        </div>

        <p className='attention mt-4 p-3'>
          各レクの「相談を開始する」ボタンをクリックして講師さんとレク実施に向けて調整を行なってください。
        </p>
      </div>

      <div className='mt-4'>
        <div className='container'>
          <div className='row'>
            {companyRecreationPlan.companyRecreationRecreationPlans.length ? (
              companyRecreationPlan.companyRecreationRecreationPlans.map(
                (companyRecreationRecreationPlan) => (
                  <div
                    className='col-md-6 mb-3'
                    key={companyRecreationRecreationPlan.month}
                  >
                    <CompanyRecreationRecreationPlanItem
                      companyRecreationRecreationPlan={
                        companyRecreationRecreationPlan
                      }
                    />
                  </div>
                )
              )
            ) : (
              <div className='m-3'>
                <p>レクリエーションが登録されていません</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

mountComponent('#companyRecreationPlanShow', () => <RecreationPlanShow />);
